var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"show-modal":_vm.showModal},on:{"close-modal":_vm.closeModal}},[_c('intervention-reassign-date-edit',{attrs:{"interventions":_vm.interventions},on:{"close-modal":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }